import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PinPage from '../../components/PinPage/PinPage';
import { PIN_SECURITY_DESCRIPTION_WITH_WARNING } from '../../utils/constant';

const CreateNewPIN = () => {
  const [pin, setPin] = useState(undefined);
  let navigate = useNavigate();
  const search = useLocation().search;
  const token = new URLSearchParams(search).get('token');
  useEffect(() => {
    if (token) {
      localStorage.setItem('access_token_temp', token);
      window.history.replaceState(null, '/forgot-pin/create-new-pin', '/forgot-pin/create-new-pin');
    }
  }, []);
  const handleSubmit = () => {
    localStorage.setItem('pin', pin);
    localStorage.setItem('restrictPage',false)
    navigate('/forgot-pin/confirm-new-pin');
  };
  return (
    <div className='auth auth--no-info-mobile'>
      <PinPage
        pin={pin}
        buttonName={'Submit'}
        authInfoTitle={'Welcome back'}
        authInfoDescription={'Enter your credentials to access your Realbricks account.'}
        authFormTitle={'Create a new 4-digit PIN'}
        authFormDescription={PIN_SECURITY_DESCRIPTION_WITH_WARNING}
        setPin={(value) => setPin(value)}
        handleSubmit={handleSubmit}
        loading={false}
      />
    </div>
  );
};

export default CreateNewPIN;
